import { ICON_COLOR, IconSpinnerOverlay } from '../Icon'

import { QA_NAME_LOADER_ICON } from './Loader.constants'

import * as styles from './Loader.module.css'

function Loader({ className = styles.Loader }) {
  return (
    <div className={className}>
      <IconSpinnerOverlay
        color={ICON_COLOR.White}
        qaName={QA_NAME_LOADER_ICON}
      />
    </div>
  )
}

export default Loader
